import { AlertsFilter } from '../../../../../shared/types/legalProceedings/alerts';

export const initialValues: AlertsFilter = {
    ruleNumber: '',
    startCreatedAt: undefined,
    endCreatedAt: undefined,
    name: '',
    status: '',
    newStatus: '',
    receptionChannel: '',
    typePQR: '',
    receivedThrough: '',
    subtypeDP: '',
    transaction: '',
    active: true,
};
